import styled from '@emotion/styled'

import { colors } from '@/styles/theme'
import { mediaUp } from '@/styles/media'
import { mediaColumns } from '@/styles/grid'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.darkSkyBlue};
  padding: 40px 0;

  ${mediaUp('lg')} {
    padding: 80px 0;
  }

  ${mediaUp('md')} {
    br {
      display: none;
    }
  }

  .legia-warszawa & {
    background-color: var(--mainCustom);
  }
`

export const StarsWrapper = styled.div`
  ${mediaColumns({ xs: [8, 2], md: [4, 1] })};
`

export const OpinionsWrapper = styled.div`
  ${mediaColumns({ xs: [12, 0], md: [6, 6] })};
`
